<template>
  <transition name="fade" mode="out-in" appear>
    <v-footer app class="invoice-footer pa-3">
      <v-row dense justify="center">
        <v-col cols="12" sm="5" md="3" lg="3" xl="2" v-if="!paid">
          <v-btn
            block
            class="white--text"
            large
            depressed
            color="deep-orange darken-1"
            @click="showDialogInvoicePayment = true"
            >Pay Now<v-icon right>mdi-currency-usd</v-icon></v-btn
          >
        </v-col>
        <v-col cols="12" sm="5" md="3" lg="3" xl="2">
          <BtnBaseBlue
            block
            large
            class="mt-0 mb-0"
            @click="showDialogInvoiceFulfillment = true"
            >Fulfillment Details
            <v-icon right>mdi-truck-outline</v-icon>
          </BtnBaseBlue>
        </v-col>
      </v-row>
    </v-footer>
  </transition>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import BtnBaseBlue from '@/components/BtnBaseBlue'
export default {
  name: 'InvoiceFooter',
  components: { BtnBaseBlue },
  props: {
    paid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapFields('order', [
      'showDialogInvoiceFulfillment',
      'showDialogInvoicePayment',
    ]),
  },
  beforeDestroy() {
    this.showDialogInvoiceFulfillment = false
    this.showDialogInvoicePayment = false
  },
}
</script>
